import * as React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

const RupeeCoinIcon = () => (
  <SVGUniqueID>
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient
          id="paint0_linear_139_58"
          x1="1.25"
          y1="1.25"
          x2="1751.25"
          y2="1751.25"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD700" />
          <stop offset="0.3" stopColor="#FFA500" />
          <stop offset="0.7" stopColor="#FFD700" />
          <stop offset="1" stopColor="#B8860B" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_139_58"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(690.625 415.625) scale(6.875)"
        >
          <stop stopColor="#FFFF99" />
          <stop offset="1" stopColor="#DAA520" />
        </radialGradient>
      </defs>
      <path
        d="M10 18.75C14.8325 18.75 18.75 14.8325 18.75 10C18.75 5.16751 14.8325 1.25 10 1.25C5.16751 1.25 1.25 5.16751 1.25 10C1.25 14.8325 5.16751 18.75 10 18.75Z"
        fill="url(#paint0_linear_139_58)"
        stroke="#B8860B"
        strokeWidth="1.25"
      />
      <path
        d="M10 16.875C13.797 16.875 16.875 13.797 16.875 10C16.875 6.20304 13.797 3.125 10 3.125C6.20304 3.125 3.125 6.20304 3.125 10C3.125 13.797 6.20304 16.875 10 16.875Z"
        fill="url(#paint1_radial_139_58)"
        stroke="#DAA520"
        strokeWidth="0.625"
      />
      <text
        fill="#8B4513"
        xmlSpace="preserve"
        style={{ whiteSpace: 'pre' }}
        fontFamily="Inter"
        fontSize="8.75"
        fontWeight="bold"
        letterSpacing="0em"
      >
        <tspan x="7.67529" y="13.0568">
          ₹
        </tspan>
      </text>
      <path
        d="M9.37477 9.49763C10.2716 8.97986 10.1591 7.10613 9.12357 5.31254C8.08804 3.51894 6.52157 2.48467 5.62477 3.00244C4.72798 3.52021 4.84044 5.39394 5.87598 7.18754C6.91151 8.98113 8.47798 10.0154 9.37477 9.49763Z"
        fill="white"
        fillOpacity="0.3"
      />
    </svg>
  </SVGUniqueID>
);

export { RupeeCoinIcon };
